import React, { useEffect, useState } from 'react';
import Navbar from '../../../components/Navbar/Navbar';
import Footer from '../../../components/Footer/Footer';
import { useGetProductsQuery } from '../../../api/productsApiSlice';
import { Spinner } from 'flowbite-react';
import { isMobile } from 'react-device-detect';
import ProductMobile from './ProductMobile';
import Cookies from 'js-cookie';
import ProductsDesktop from './ProductsDesktop';
import SideNavbar from '../../../components/SideNavbar';

const Products = () => {
  const currentUser = Cookies.get('currentUser')
    ? JSON.parse(Cookies.get('currentUser'))
    : null;

  const {
    data: product,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useGetProductsQuery({ storeId: currentUser?.store?._id });

  useEffect(() => {
    refetch();
  }, []);

  let content;

  if (isLoading || isFetching) {
    content = (
      <div
        className="w-full flex items-center justify-center"
        style={{ height: '600px' }}
      >
        <Spinner />
      </div>
    );
  } else if (isSuccess) {
    content = isMobile ? (
      <ProductMobile product={product} />
    ) : (
      <ProductsDesktop
        product={product}
        currentUser={currentUser}
        refetch={refetch}
      />
    );
  }

  const styles = isMobile
    ? 'w-full mx-auto h-screen bg-white mt-16'
    : 'w-full mx-auto h-screen bg-white ml-2';

  return (
    <>
      <Navbar />
      <div className="flex mx-auto max-w-6xl">
        <SideNavbar />
        <div className={styles}>{content}</div>
      </div>
      <Footer />
    </>
  );
};

export default Products;
